import styled from 'styled-components';
import {
  zIndex,
  hideVisually,
  Link
} from '@comicrelief/component-library';

const Wrapper = styled.div`
  font-family: ${({ theme }) => theme.fontFamilies(theme.font.regular)};

  h1 {
    word-break: normal;
  }

  background-color: ${({ backgroundColour, theme }) => (theme.color(backgroundColour))};
`;

const SkipNav = styled(Link)`
  ${hideVisually};
  text-decoration: none;
  top: 0;
  :focus {
    margin: 0;
    left: 50%;
    ${zIndex('higher')};
   line-height: 2rem;
    clip: auto;
    clip-path: none;
    overflow: visible;
  }
`;

const Main = styled.main`
  display: block;
  position: relative;
  z-index: 1;
  clip-path: inset(-25px 0% 0% 0% round 25px);
`;

const HeaderWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 2;
  padding: 16px 16px 0;

  @media ${({ theme }) => theme.breakpoints2026('L')} {
    padding: 18px 32px 0;
  }
`;

const ContentArea = styled.div`
  position: relative;
  z-index: 0;
`;

const FooterWrapper = styled.div`
  position: relative;
  z-index: 0;
  margin-top: -25px;
`;

export {
  Wrapper, SkipNav, Main, HeaderWrapper, ContentArea, FooterWrapper
};
